<div *ngIf="!showRequest">
  <div *ngIf="baseRequestId" class="">

    <h2 class="sectionTitle">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TREASURY_NUMBERS'| translate}}</h2>
    <div *ngIf="baseRequestDTO" class="read-only-content">
      <!--request Details summary-->
       <app-update-agent-profile [IsAdminMode]="true" [RequestStatus]="requestStatus" [AgentId]="agentId"></app-update-agent-profile>
    </div>

    <form [formGroup]="registerTreasuryNumberForm" >
      <div class="form-container">
        <h4 class="section-title">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TREASURY_NUMBER'| translate}}</h4>
      </div>
      <div formArrayName="AgentCurrencyDto">
        <div class="form-container"
          *ngFor="let currency of registerTreasuryNumberForm.get('AgentCurrencyDto').controls; let i=index; let last = last"
          [formGroupName]="i">

          <div class="form-group">
            <label for="">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TREASURY_NUMBER'| translate}}</label>
            <span class="red"> *</span>
            <div class="input-group">
              <span class="input-group-addon"> {{currency.get('CurrencyName').value}}</span>

              <input type="text" formControlName="TreasuryNumber" class="form-control" id="TreasuryNumber"
                (change)="onChangeTreasury($event,currency.get('TreasuryNumber'))" name="TreasuryNumber"
                [ngClass]="{ 'is-invalid': submitted ||(currency.get('TreasuryNumber')?.dirty && currency.get('TreasuryNumber')?.errors) }" />
            </div>

            <div *ngIf=" submitted ||(currency.get('TreasuryNumber')?.dirty &&  currency.get('TreasuryNumber')?.errors)"
              class="red">
              <div *ngIf="currency.get('TreasuryNumber')?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required'| translate}}
              </div>
              <div *ngIf="currency.get('TreasuryNumber')?.errors?.duplicatedNumber">
                {{'FRONT_USER.ERRORS_MESSAGES.DuplicateTreasuryNumber' | translate}}
              </div>
            </div>

          </div>
          <input type="hidden" formControlName="CurrencyId" />
          <input type="hidden" formControlName="Id" />
          <input type="hidden" formControlName="AgentId" />

        </div>
      </div>

      <p *ngIf="formMode == FormMode.Add" class="form-group">
        <button Confirmation  (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SUBMIT' | translate}}</button>
      </p>
    </form>

  </div>
</div>
<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage && !DuplicateTreasuryNumber" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TREASURY_NUMBER_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>

  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>

        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
</div>


<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
      </div>
  </div>

  <div *ngIf="showRequest && DuplicateTreasuryNumber" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.DuplicateTreasuryNumber' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
      </div>
  </div>
